import DOMPurify from 'isomorphic-dompurify';
import Image from 'next/future/image';
import { FormattedMessage } from 'react-intl';

const CommunityInvolvement = (props: any) => {
  const { blogData } = props;
  return (
    <div>
      <section className="sv-community-involvement">
        <div className="container">
          <h2 className="section-heading">
            <FormattedMessage id="community-involvement" />
          </h2>
          <div className="row align-items-center justify-content-center gx-3">
            <div className="col-lg-6 col-md-6 col-12">
              <Image
                sizes="(max-width: 375px) 295px, (max-width: 576px) 290px, (max-width: 768px) 350px, (max-width: 992px) 470px, (max-width: 1280px) 550px"
                src={blogData?.Thumbnail?.data?.attributes?.url}
                className="card-img-top community-img"
                alt={
                  blogData?.Thumbnail?.data?.attributes?.alternativeText ||
                  blogData?.Thumbnail?.data?.attributes?.name
                }
                width="370"
                height="300"
              />
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <h3>{blogData?.Title}</h3>
              <div
                className="card-content"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(blogData?.Excerpt),
                }}
              ></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CommunityInvolvement;
